import type { QueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { getEligibility, useProductOfferStore } from "@/sales-tools";
import type { EligibilityRequest } from "../types";

const QUERY_KEY = "sales-eligibility";

export const useEligibility = (request: EligibilityRequest, isEnabled = true) => {
    const { data, isLoading, isError, error } = useQuery({
        queryKey: [
            QUERY_KEY,
            request.customerMdn,
            request.sessionId,
            request.customer?.accountNumber,
            request.eligibilityAttributes?.currentSubscriptions,
        ],
        queryFn: async () =>
            getEligibility({
                ...request,
            }),
        staleTime: Infinity,
        gcTime: Infinity,
        retry: 1,
        enabled: isEnabled,
    });

    if (data) {
        useProductOfferStore.getState().updateEligibilityMetaBySessionId(request.sessionId, data.meta);
    }

    return { data, isLoading, isError, error };
};

export const clearEligibilityQueryCache = (queryClient: QueryClient, sessionId: string) => {
    queryClient.removeQueries({
        predicate: (query) => query.queryKey.includes(QUERY_KEY) && query.queryKey.includes(sessionId),
    });
};
